import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpCancelService } from './services/http-cancel.service';
import { HttpInterceptorParams } from '@app/core/interceptors/classes/http-interceptor-params';

export function cancelPendingRequestsInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const httpCancelService = inject(HttpCancelService);

  return next(request).pipe(
    takeUntil(
      httpCancelService.onCancelPendingRequests().pipe(
        filter(forceCancellation => {
          return (
            forceCancellation ||
            !(
              request.params instanceof HttpInterceptorParams &&
              request.params.interceptorConfig.toIgnoreNavigationCancellation
            )
          );
        })
      )
    )
  );
}
